import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Everything you need to know about Basetao Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="border border-background-200 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left bg-background-50 hover:bg-background-100 transition-colors duration-150 cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-2">
                  {item.question}
                </span>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg text-primary-500 transition-transform duration-200`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}